import React from "react";
import { useField } from "formik";
import { Form, FormControl, InputGroup } from "react-bootstrap";

const ReactCheckbox = ({ ...props }) => {
  const [field, meta] = useField(props);

  return (
    <InputGroup>
      <Form.Check
        type="checkbox"
        {...field}
        {...props}
        isInvalid={meta.touched && meta.error}
        checked={field.value}
      />
      {meta.touched && meta.error && (
        <FormControl.Feedback type="invalid">
          {meta?.error}
        </FormControl.Feedback>
      )}
    </InputGroup>
  );
};

export default ReactCheckbox;
